module.exports = __webpack_public_path__ + "img/kt-drbrian02.3b06bb54.jpg";